import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  visibilitySection: {
    display: 'flex',
    flexDirection: 'column',
    '> p': {
      padding: 0,
      margin: 0,
    },
    gap: theme.spacing(1),
  },
  spacerRow: {
    marginTop: theme.spacing(1.5),
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
    '& > .MuiBox-root': {
      width: `calc(100% + ${theme.spacing(15)})`,
      paddingRight: theme.spacing(13.25),
      '> div': {
        gap: theme.spacing(3),
      },
    },
  },
  // Redesigned drawer body: a plain single-column scroll container (no legacy two-column width hack).
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
  },
  paymentId: {
    margin: `${theme.spacing(1)} 0px`,
    '& .MuiInputBase-input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.background.paper,
    },
  },
  link: {
    color: theme.palette.primary.main,
    maxWidth: 223,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  openIcon: {
    height: 14,
    width: 14,
    marginBottom: 2,
    marginLeft: 2,
  },
  thinRow: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(3),
    '.MuiFormControl-root': {
      margin: 0,
    },
  },
  payeeField: {
    display: 'flex',
    flex: 2,
    margin: 0,
  },
  dateField: {
    flex: 1,
  },
  refundLine: {
    display: 'flex',
    justifyContent: 'space-between',
    textAlign: 'right',
    paddingLeft: 14,
  },
  refundAfterAmountRow: {
    marginTop: -24,
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: theme.palette.divider,
  },
  bottomSection: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: 24,
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '> div': {
      width: '100%',
    },
  },
  recurringRoot: {
    padding: theme.spacing(3),
    display: 'flex',
    minHeight: 464,
  },
  recurringColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(2),
  },
  recurringSubtitle: {
    paddingBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  createRuleButton: {
    marginRight: theme.spacing(1),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
  },
  updateButton: {
    marginLeft: 0,
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  editSplitAmount: {
    margin: 0,
    padding: 0,
    height: 58,
    borderRadius: 12,
    border: `1px solid ${theme.palette.border.light}`,
    boxShadow: theme.shadows[1],
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  dividerSection: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  clientProjectSelect: {},
  notesAndAttachmentsSetWidth: {
    maxWidth: 348,
    gap: theme.spacing(2),
  },
  dialogIllustration: {
    width: '100px',
    height: '100px',
  },
  dialogContent: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(5),
  },
  dialogContentTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));
